<template>
  <div
    v-if="notification"
    class="notification-dialog-overlay"
    @click="handleClose"
  >
    <div
      class="notification-dialog"
      @click.stop
    >
      <div class="notification-dialog-header">
        <h3>{{ getNotificationTitle(notification) }}</h3>
        <button
          class="notification-dialog-close"
          @click="handleClose"
          :aria-label="t('notifications.close', 'Close')"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line
              x1="18"
              y1="6"
              x2="6"
              y2="18"
            />
            <line
              x1="6"
              y1="6"
              x2="18"
              y2="18"
            />
          </svg>
        </button>
      </div>
      <div class="notification-dialog-body">
        <NotificationMessage
          :notification="notification"
          :show-debug-data="showDebugData"
          @action="handleAction"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import NotificationMessage from './NotificationMessage.vue';

defineProps({
  notification: {
    type: Object,
    default: null
  },
  r7eApp: {
    type: Object,
    default: null
  },
  showDebugData: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close']);

const { t } = useI18n();

const getNotificationTitle = (item) => {
  let key = '';
  if (item.title) {
    key = item.title;
  } else if (item.type) {
    key = item.type;
  }
  const t_key = `notifications.types.${key}`;
  const translated = t(t_key);
  if (translated !== t_key) {
    return translated;
  }
  return key;
};

const handleAction = () => {
  // Close dialog after action is triggered
  handleClose();
};

const handleClose = () => {
  emit('close');
};
</script>

<style scoped lang="scss">
.notification-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.notification-dialog {
  background-color: var(--color-bg);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  max-width: 600px;
  max-height: 80vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-border);
}

.notification-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--color-border);
}

.notification-dialog-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-text);
}

.notification-dialog-close {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--color-text);
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.notification-dialog-close:hover {
  opacity: 1;
}

.notification-dialog-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

@media (max-width: 900px) {
  .notification-dialog {
    max-width: 100%;
    max-height: 90vh;
    margin: 10px;
  }

  .notification-dialog-overlay {
    padding: 10px;
  }
}
</style>

